import React from 'react';

import {
  Flex,
  Button,
  FormControl,
  Input,
  useColorModeValue,
  useColorMode,
  Grid,
  GridItem,
  Box,
} from '@chakra-ui/react';

import routes from '../../routes';

import Sidebar from '../../Components/Sidebar';
import Conversations from '../Conversations';

const ProspectsLayout = () => {
  return (
    <Flex direction="row" position="relative" w="100%" h="100vh">
      <Sidebar routes={routes} />
      <Conversations />
    </Flex>
  );
};

export default ProspectsLayout;
